import {Bitmovin8Adapter} from './adapters/bitmovin8/Bitmovin8Adapter';
import {PlayerModule} from './adapters/bitmovin8/playerModule';
import {CdnProvider} from './enums/CDNProvider';
import {Player} from './enums/Player';
import {VERSION} from './utils/Version';

export {VERSION as version};

export type {AnalyticsConfig} from './types/AnalyticsConfig';

export {Player as Players};
export {CdnProvider as CdnProviders};

export {Bitmovin8Adapter};

export const adapters = {
  Bitmovin8Adapter,
};

export {PlayerModule};

export default {
  PlayerModule: PlayerModule,
};
